import React from "react";
import { Star } from "lucide-react";

export default function MyHealthReviews({
  pending = [],
  recent = [],
  onWriteReview,
}) {
  return (
    <section className="p2-myhealth-reviews">
      <p className="p2-myhealth-reviews-title">Vlerësimet e mia</p>

      {pending.length > 0 && (
        <div className="p2-myhealth-reviews-pending">
          <p className="p2-myhealth-reviews-pending-title">
            Për t’u vlerësuar
          </p>

          <div className="p2-myhealth-reviews-pending-list">
            {pending.map((p) => (
              <div key={p.id} className="p2-myhealth-reviews-pending-item">
                <div className="p2-myhealth-reviews-pending-icon">
                  <Star className="p2-myhealth-reviews-pending-icon-svg" />
                </div>

                <div className="p2-myhealth-reviews-pending-main">
                  <p className="p2-myhealth-reviews-pending-name">
                    Dr. {p.doctorName || p?.doctorInfo?.name || "—"}
                  </p>
                  <p className="p2-myhealth-reviews-pending-sub">
                    {(p.specialty || p?.doctorInfo?.specialty || "Mjek") +
                      " • " +
                      (p.dateLabel || "Vizitë e përfunduar")}
                  </p>
                </div>

                <button
                  type="button"
                  className="p2-myhealth-reviews-pending-btn"
                  onClick={() => onWriteReview?.(p)}
                >
                  Shkruaj
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <p className="p2-myhealth-reviews-recent-title">
        Vlerësimet e fundit
      </p>

      {recent.length === 0 ? (
        <p className="p2-myhealth-reviews-recent-empty">
          Ende nuk ke lënë asnjë vlerësim…
        </p>
      ) : (
        <div className="p2-myhealth-reviews-recent-list">
          {recent.map((r) => (
            <div key={r.id} className="p2-myhealth-reviews-recent-item">
              <p className="p2-myhealth-reviews-recent-name">
                Dr. {r.doctorName || r?.doctorInfo?.name || "—"}{" "}
                {r.specialty || r?.doctorInfo?.specialty
                  ? `• ${r.specialty || r?.doctorInfo?.specialty}`
                  : ""}
              </p>

              {r.comment && (
                <p className="p2-myhealth-reviews-recent-comment">
                  “{r.comment}”
                </p>
              )}

              {r.dateLabel && (
                <p className="p2-myhealth-reviews-recent-date">
                  {r.dateLabel}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
